// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HeatMapOutlinedSvg from "@fishx/icons-svg/es/asn/HeatMapOutlined";
import FishxIcon from '../components/FishxIcon';

var HeatMapOutlined = function HeatMapOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HeatMapOutlinedSvg
  }));
};

HeatMapOutlined.displayName = 'HeatMapOutlined';
export default React.forwardRef(HeatMapOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HeatMapOutlined.js
// module id = 2917
// module chunks = 0